/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsGallery = {
  init: function($section) {
    // Add settings from schema to current object
    Shopify.theme.jsGallery = $.extend(this, Shopify.theme.getSectionData($section));

    let gutterSize = 0;
    if(this.show_gutter == true) {
      gutterSize = 20
    }

    if(this.gallery_type == 'masonry') {
      Shopify.theme.applyMasonry('.gallery__item', gutterSize);
    } else if(this.gallery_type == 'horizontal-masonry') {
      Shopify.theme.applyHorizontalMasonry();
    }

    if ($(window).width() < 669) {
      const $gallarySlider = $("[data-gallary-slider]");
      if( $gallarySlider.length > 0 ) {
          $gallarySlider.flickity({
              cellAlign: 'left',
              pageDots: true,
              contain: true,
              wrapAround: false,
              imagesLoaded: true
          });
      }
    }
  },
  unload: function($section) {

  }
}

/******/ })()
;